import Auth from 'shared/context/Auth'
import { queryKeys } from 'hooks/queryKeys'
import { useQuery } from '@tanstack/react-query'
import type { TrackingUserLastTime } from 'shared/context/Auth'

interface UseTrackingUserLastQueryOptions {
  projectName?: string
  page?: string | number
  userId?: string
  enabled?: boolean
}

/** Cached last-visit lookup — shared with AuthContext.fetchLastTime via the same query key. */
export function useTrackingUserLastQuery({
  projectName = '',
  page = '',
  userId,
  enabled = true,
}: UseTrackingUserLastQueryOptions) {
  const pageKey = String(page)

  return useQuery({
    queryKey: queryKeys.trackingUserLast(projectName, pageKey, userId),
    queryFn: (): Promise<TrackingUserLastTime | null> =>
      Auth.fetchTrackingUserLastTime({
        filter: { projectName, page: pageKey, ...(userId ? { userId } : {}) },
      }),
    enabled: enabled && !!projectName && !!pageKey,
  })
}
